import { useState, useEffect, useCallback } from 'react'

// export const screenSizeMap = {
//   xs: 'xs',
//   s: 's',
//   m: 'm',
//   l: 'l',
//   xl: 'xl'
// }

export const deviceMap = {
  mobile: 'mobile',
  desktop: 'desktop'
}

// Hook
export const useScreenSize = () => {
  const isClient = typeof window === 'object'

  const getSize = useCallback(() => {
    return {
      width: isClient ? window.innerWidth : 0,
      height: isClient ? window.innerHeight : 0,
      device: deviceMap.mobile
    }
  }, [isClient])

  const [windowSize, setWindowSize] = useState(getSize)

  useEffect(() => {
    if (!isClient) {
      return
    }

    function handleResize() {
      setWindowSize(getSize())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isClient, getSize]) // Empty array ensures that effect is only run on mount and unmount

  if (windowSize.width > 1120) {
    windowSize.device = deviceMap.desktop
  } else {
    windowSize.device = deviceMap.mobile
  }

  // if (windowSize.width < 576) {
  //   windowSize.screen = screenSizeMap.xs
  // } else if (windowSize.width >= 576 && windowSize.width < 768) {
  //   windowSize.screen = screenSizeMap.s
  // } else if (windowSize.width >= 768 && windowSize.width < 992) {
  //   windowSize.screen = screenSizeMap.m
  // } else if (windowSize.width >= 992 && windowSize.width < 1200) {
  //   windowSize.screen = screenSizeMap.l
  // } else {
  //   windowSize.screen = screenSizeMap.xl
  // }

  return windowSize
}
